import type { ReactNode } from 'react';
import type { IconName } from 'shared/components/Icon';
import type { VisitorAlert, RoutingRule, Journey, Segment } from './';

export enum AutomationKey {
  ALERTS = 'alerts',
  ROUTING_RULES = 'routing-rules',
  JOURNEYS = 'journeys',
  SEGMENTS = 'segments',
}

type AutomationItemTag = { title: string; tooltip: ReactNode };

type AutomationItem = {
  tags?: AutomationItemTag[];
};

export type AutomationTypeMap = {
  [AutomationKey.ALERTS]: VisitorAlert & AutomationItem;
  [AutomationKey.ROUTING_RULES]: RoutingRule & AutomationItem;
  [AutomationKey.JOURNEYS]: Journey & AutomationItem;
  [AutomationKey.SEGMENTS]: Segment &
    AutomationItem & {
      enabled?: boolean;
      dateUpdated?: number | null;
    };
};

export type AutomationDataMap = {
  [AutomationKey.ALERTS]: AutomationTypeMap[AutomationKey.ALERTS][];
  [AutomationKey.ROUTING_RULES]: AutomationTypeMap[AutomationKey.ROUTING_RULES][];
  [AutomationKey.JOURNEYS]: AutomationTypeMap[AutomationKey.JOURNEYS][];
  [AutomationKey.SEGMENTS]: AutomationTypeMap[AutomationKey.SEGMENTS][];
};

export interface AutomationShape {
  id: AutomationKey;
  name: string;
  noun: string;
  icon: IconName;
  img: ReactNode;
  color: string;
  copy: string;
  cta: string;
  path: string;
  extraActions?: ReactNode;
}
